import React from 'react';

import { range } from 'lodash';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

// Placeholder rows for the Project Plan grid while the first fetch is in flight.
//
// Not CommonComponents/TableRowSkeleton: that emits <tr>/<td> for real HTML tables, and this grid
// is a react-virtualized MultiGrid of absolutely-positioned divs. Reusing it here would put table
// rows inside a div grid.
//
// The geometry is passed in rather than imported from GanttChart, which owns ROW_HEIGHT and
// FIXED_COLUMN_WIDTHS. GanttChart renders this component, so importing them back would be a
// circular import — and duplicating the numbers would let them drift. Feeding the real values in
// keeps one source of truth and means the placeholder rows line up with the columns that replace
// them, so the layout does not jump when data lands.
const GanttChartSkeleton = ({ fixedColumns = [], fixedColumnWidths = {}, rowHeight = 35, rowCount = 10 }) => {
    return (
        <SkeletonTheme borderRadius="0.25rem">
            {/* aria-hidden: the loading state is already announced by the progress indicator that
                sits over this. Exposing a dozen decorative placeholder bars as well would just be
                noise to a screen reader. */}
            <div className="tw-absolute tw-inset-0 tw-overflow-hidden" aria-hidden="true">
                {range(rowCount).map((row) => (
                    <div key={row} className="tw-flex tw-items-center" style={{ height: rowHeight }}>
                        {fixedColumns.map((columnKey) => (
                            <div key={columnKey} className="tw-flex-none tw-px-2.5" style={{ width: fixedColumnWidths[columnKey] }}>
                                {/* The name column carries the tree, so its placeholder is the
                                    wide one; the rest are chips and counts. Indented on
                                    alternating rows to hint at the category/activity nesting
                                    rather than reading as a flat list. */}
                                <Skeleton height={12} width={columnKey === 'name' ? `${row % 3 === 0 ? 55 : 40}%` : '70%'} />
                            </div>
                        ))}
                        {/* The timeline. One bar per row at a varying offset and width, so the
                            placeholder reads as a gantt rather than a solid block. */}
                        <div className="tw-flex-1 tw-px-2.5">
                            <Skeleton height={12} width={`${25 + ((row * 13) % 40)}%`} style={{ marginInlineStart: `${(row * 17) % 45}%` }} />
                        </div>
                    </div>
                ))}
            </div>
        </SkeletonTheme>
    );
};

export default GanttChartSkeleton;
